import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { pageFactory } from "../modules/factory";


export class vnAppZoneHeader extends vnAppZone {

    public constructor(destination, appInterface: string | null = null) {
        super(destination, appInterface);
        this.zoneName = "Header";
    }

    defineRoutes(appInterface) {

        let factory = new pageFactory();
        let _mythis = this;

        //define routes
        this.addForRoute('all', function () {

            // obtain the right module object
            let moduleObj = factory.get_actionHandler("header", _mythis);

            // load it into the zone
            _mythis.loadModule(moduleObj);
        }, null);

        this.addForRoute('/header', function () {
        }, null);

        this.addForRoute('/signup', function () {

            // obtain the right module object
            let moduleObj = factory.get_actionHandler("headerPromo", _mythis);

            // load it into the zone
            _mythis.loadModule(moduleObj);
        }, null);

        this.addForRoute('/emailConfirmation/token/:token', function () {

            // obtain the right module object
            let moduleObj = factory.get_actionHandler("headerPromo", _mythis);

            // load it into the zone
            _mythis.loadModule(moduleObj);
        }, null);

        this.addForRoute('/notification/optOut/:token', function(){

            // obtain the right module object
            let moduleObj = factory.get_actionHandler("headerPromo", _mythis);

            // load it into the zone
            _mythis.loadModule(moduleObj);
        }, null );

    }
}



// WEBPACK FOOTER //
// ./js/components/vn_app_zone_header.ts